import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomer,
  BackendCustomerInvoicesArgs,
  BackendQueryCustomerArgs,
} from 'src/types/backend';

const QUERY = gql`
  query CustomerInvoices(
    $customerId: ID!
    $after: String
    $first: Int
    $status: InvoiceStatusEnum
  ) {
    customer(id: $customerId) {
      id
      invoices(first: $first, after: $after, status: $status) {
        edges {
          node {
            stripeId
            createdAt
            status
            amountDue
            amountPaid
            description
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

type Variables = {
  customerId: BackendQueryCustomerArgs['id'];
} & Pick<BackendCustomerInvoicesArgs, 'after' | 'first' | 'status'>;
type Result = Pick<BackendCustomer, 'id' | 'invoices'>;

export const queryCustomerInvoices = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data)?.invoices;
};
